import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  return <section className="w-full bg-white py-24 px-4 sm:px-6 lg:px-8" data-id="element-116">
      <div ref={ref} className={`max-w-[700px] mx-auto text-center transition-all duration-1000 transform ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`} data-id="element-117">
        <div className="w-[120px] h-[120px] mx-auto rounded-full border-[3px] border-gold flex flex-col items-center justify-center mb-8 bg-gold/5 shadow-[0_0_30px_rgba(245,166,35,0.15)]" data-id="element-118">
          <ShieldCheck size={40} className="text-gold mb-1" data-id="element-119" />
          <span className="font-montserrat font-bold text-gold text-sm tracking-widest" data-id="element-120">
            7 DÍAS
          </span>
        </div>

        <h2 className="font-playfair font-bold text-3xl sm:text-4xl text-navy mb-6" data-id="element-121">
          Garantía de Acceso por 7 Días
        </h2>

        <p className="font-inter text-lg text-gray-600 leading-relaxed" data-id="element-122">
          Si dentro de los primeros 7 días tenés cualquier inconveniente de
          acceso al material, problemas técnicos o dificultades para visualizar
          el contenido, te ayudamos a resolverlo de inmediato o te devolvemos el
          100% de tu dinero. Tu compra está protegida.
        </p>
      </div>
    </section>;
}